import React from 'react';
import { Link } from 'react-router-dom';

const CourseGrid = () => {
  const courses = [
    {
      id: 1,
      title: 'NEET',
      subtitle: 'Class 11th, 12th, Repeater',
      description: 'Comprehensive NEET preparation with expert faculty, detailed study material, and extensive test series.',
      image: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=600&h=400&fit=crop',
      icon: '🏥',
      features: ['Live & Recorded Classes', '3500+ Tests', 'Doubt Solving', 'Study Material'],
      duration: '1 Year',
      price: '₹25,000',
    },
    {
      id: 2,
      title: 'JEE',
      subtitle: 'Class 11th, 12th',
      description: 'Focused JEE Main & Advanced preparation with strong concept building and problem-solving skills.',
      image: 'https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=600&h=400&fit=crop',
      icon: '⚡',
      features: ['Expert Faculty', 'Mock Tests', 'Study Material', 'Doubt Sessions'],
      duration: '1 Year',
      price: '₹30,000',
    },
    {
      id: 3,
      title: 'MHT-CET',
      subtitle: 'Class 11th, 12th',
      description: 'Targeted MHT-CET program with complete syllabus coverage and intensive practice sessions.',
      image: 'https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?w=400&h=250&fit=crop',
      icon: '📊',
      features: ['Syllabus Coverage', 'Practice Sessions', 'Mock Tests', 'Study Material'],
      duration: '6 Months',
      price: '₹15,000',
    },
    {
      id: 4,
      title: 'Foundation',
      subtitle: '6th to 10th',
      description: 'Foundation courses to strengthen Science & Math concepts for future competitive exams.',
      image: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=600&h=400&fit=crop',
      icon: '🏗️',
      features: ['Concept Building', 'Regular Tests', 'Study Material', 'Doubt Solving'],
      duration: '1 Year',
      price: '₹12,000',
    },
    {
      id: 5,
      title: 'Online Test Series',
      subtitle: 'All Exams',
      description: 'Comprehensive online test series with instant results and performance analytics.',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&h=400&fit=crop',
      icon: '💻',
      features: ['3500+ Tests', 'Instant Results', 'Performance Analytics', 'All India Rank'],
      duration: '1 Year',
      price: '₹5,000',
    },
    {
      id: 6,
      title: 'Offline Classes',
      subtitle: 'Pune Center',
      description: 'Interactive classroom programs with doubt-solving and personalized guidance.',
      image: 'https://images.unsplash.com/photo-1509062522246-3755977927d7?w=600&h=400&fit=crop',
      icon: '🏫',
      features: ['Interactive Classes', 'Doubt Solving', 'Personalized Guidance', 'Study Material'],
      duration: '1 Year',
      price: '₹35,000',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      {courses.map((course) => (
        <div key={course.id} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
          <div className="relative">
            <img
              src={course.image}
              alt={course.title}
              className="w-full h-48 object-cover"
            />
            <div className="absolute top-4 right-4 bg-primary text-white p-3 rounded-full">
              <span className="text-2xl">{course.icon}</span>
            </div>
          </div>
          <div className="p-6">
            <h3 className="text-2xl font-bold text-gray-900 mb-2">
              {course.title}
            </h3>
            <p className="text-primary font-medium mb-3">
              {course.subtitle}
            </p>
            <p className="text-gray-600 mb-4">
              {course.description}
            </p>
            
            <div className="mb-4">
              <h4 className="font-semibold text-gray-900 mb-2">Features:</h4>
              <ul className="space-y-1">
                {course.features.map((feature, index) => (
                  <li key={index} className="flex items-center text-sm text-gray-600">
                    <span className="text-green-500 mr-2">✓</span>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
            
            {/* <div className="flex justify-between items-center mb-4">
              <div>
                <span className="text-sm text-gray-500">Duration</span>
                <div className="font-semibold">{course.duration}</div>
              </div>
              <div>
                <span className="text-sm text-gray-500">Price</span>
                <div className="font-bold text-xl text-primary">{course.price}</div>
              </div>
            </div> */}
            
            <div className="flex gap-2">
              <Link
                to={`/courses/${course.id}`}
                className="flex-1 bg-primary text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors text-center font-medium"
              >
                View Details
              </Link>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CourseGrid;